import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import React, { useState } from "react"
import { StyleSheet, View } from "react-native"
const moment = require("moment")
import { baseColors } from "@Constants/baseStyles"
import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import { VideoPoint } from "@Screens/Diagnostic/VideoPoint"
import { EventName } from "@Constants/constant"

moment.locale("fr")

export const AppointmentForm = ({}) => {
    const [appointement, setAppointment] = useState(null)

    return (
        <ContainerStackScreen style={{ backgroundColor: baseColors.white, paddingHorizontal: 0 }}>
            <CustomScrollview paddingTop={0}>
                <View style={{ backgroundColor: baseColors.black }}>
                    <Spacer height={20} />
                    <View style={{ backgroundColor: baseColors.black, padding: 20, paddingBottom: 50 }}>
                        <BreeSerifText textAlign={"center"} fontSize={22} color={baseColors.white}>
                            Rendez-vous
                        </BreeSerifText>
                        <Spacer height={10} />
                        <OpenSansText textAlign={"left"} fontSize={16} color={baseColors.white}>
                            Planifiez un entretien de suivi avec l’un de nos soignants.
                        </OpenSansText>
                    </View>
                    <View style={styles.overlay}>
                        <VideoPoint
                            isSimpleRdv
                            eventType={EventName.ENTRETIEN_INDIVIDUELLE}
                            handleChange={(apntment) => setAppointment(apntment)}
                        />
                    </View>
                </View>
            </CustomScrollview>
        </ContainerStackScreen>
    )
}

const styles = StyleSheet.create({
    overlay: {
        marginTop: -15,
        width: "100%",
        borderTopLeftRadius: 15,
        borderTopRightRadius: 15,
        backgroundColor: "white",
        padding: 20
    },
    row: {
        width: "100%",
        flexDirection: "row",
        justifyContent: "space-between"
    }
})
